define('views/content/store',['require','backbone','views/components/store_product/store_products','collections/products','views/components/store_basket/store_basket','collections/product_categories','text!templates/content/store.html'],function(require){

    var Backbone = require('backbone');

    var StoreProductsView = require('views/components/store_product/store_products');
    var ProductsCollection = require('collections/products');
    var StoreBasketView = require('views/components/store_basket/store_basket');
    var CategoryCollection = require('collections/product_categories');
    var temp = require("text!templates/content/store.html");

    return Backbone.Marionette.LayoutView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'reseller-page',
        titleKey: 'store',

        initialize: function(options) {
            App.context.changePageTitle(App.polyglot.t(this.titleKey));

            //this.productsCollection = new ProductsCollection();
            this.categoryCollection = new CategoryCollection();

            // Update collection limit to fetch all products in this page
           // this.productsCollection.limit = 100;

        },

        regions: function() {
            return {
                StoreContainer: ".store-container",
                BasketContainer: ".basket-container"
            };
        },

        onRender: function() {
            this.StoreContainer.show(new StoreProductsView({
                collection: this.categoryCollection
            }));

            this.BasketContainer.show(new StoreBasketView());
        }

    });
});
